import { Injectable } from "@angular/core";

import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";
import { fetchDialogflowResponse, fetchDialogflowResponseFailure, fetchDialogflowResponseSuccess } from "./dilogflow.actions";
import { DialogflowService } from "../../core/services/dilogflow.service"

@Injectable()
export class DialogflowEffects {

  
  // Fetch Dialogflow Response
  fetchDialogflowResponse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchDialogflowResponse),
      tap(() => console.log("INSIDE DIALOG EFFECT")),
      mergeMap(({ postdata }) =>
        this.dialogflowservice.fetchDialogflowResponse(postdata).pipe(
          map((messagedata) => (fetchDialogflowResponseSuccess(messagedata))),
          catchError((error) => of(fetchDialogflowResponseFailure({ error })))
        )
      ),
    ),
  );

  


  constructor(
    private actions$: Actions,
    private dialogflowservice : DialogflowService
  ) {
  }
}